// ROLES
/*eslint-disable*/
export const PRINCIPAL_ROLE = 'principal'
export const PARENT_ROLE = 'parent'
export const TEACHER_ROLE = 'teacher'
export const ADMIN_ROLE = 'admin'
export const defaultProfileImage = 'https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png'

export const CLASSROOM_TYPE_COLOR = {
    "Sick Room": '#DC001B',
    active: 'white',
    inactive: '#CCCCCC',
}

export const CLASSROOM_TYPE_COLOR_HOVER = {
    "Sick Room": '#bdbdbd',
    active: '#0071b5',
    inactive: '#bdbdbd',
}

export const CLASSROOM_TYPE_COLOR_BACKGROUND = {
    inactive: '#D8D8D8',
    "Sick Room": '#D8D8D8',
    active: '#008CE0',
}

export const CLASSROOM_TYPE_COLOR_INFO = {
    inactive: '#4A4A4A',
    "Sick Room": '#4A4A4A',
    active: 'white',
}

export const CLASSROOM_TYPE_ICON = {
    inactive: 'assets/people_icon.svg',
    "Sick Room": 'assets/symptom_icon.svg',
    active: 'assets/people_icon.svg',
}

export const CHILDREN_STATUS_SMALL_DIV = {
    Advenio: '#75B753',
    Inactive: 'gray',
    Home: '#808080',
    "Nurse's Room": '#D0021B',
}

export const CHILDREN_STATUS_SMALL_INNER_DIV = {
    Advenio: '#75B753',
    Inactive: 'white',
    Home: 'white',
    "Nurse's Room": '#D0021B',
}

export const STATUS_DIV = {
    Advenio: 'white',
    Inactive: '#cbcbcb',
    Home: '#cbcbcb',
    "Nurse's Room": '#D0021B',
}

export const CHILDRENS_DIV = {
    Advenio: 'white',
    Inactive: '#cbcbcb',
    Home: '#cbcbcb',
    "Nurse's Room": 'white',
}
export const CHILDRENS_LIST_TAB = {
    todos: 'Todos',
    presentes: 'Presentes',
    ausentes: 'Ausentes',
}
export const TABS_STUDENT_PROFILE = {
    recent_activity: 'Actividad Reciente',
    profile: 'Perfil',
    contract: 'Convenios',
    cards: 'Tarjetas',
    documents: 'Documentos'
}

export const PROFILE_PANNEL_LABELS = {
    inventario: 'INVENTORY',
    hours: 'Horas',
    diapers: 'Pañales',
    parents: 'PADRES',
    borthers: 'HERMANOS',
    check_in: 'Formato de entrada',
    daily_val: 'Agregar valoracion diaria',
    report_issue: 'Reportar Incidente',
    logout: 'Cerrar Sesion',
}
export const ADD_ACTIVITY = 'Agregar Actividad'

export const VIEW_MORE = 'Ver más...'

export default {
    PRINCIPAL_ROLE: 'principal',
    PARENT_ROLE: 'parent',
    TEACHER_ROLE: 'teacher',
    ADMIN_ROLE: 'admin'
}


// WEBPACK FOOTER //
// ./src/Constants.js